import {
  MelcoModelsUserDeviceListItem,
  useAPIQuery,
  UserAccountApi,
} from "melco-shared-logic";
import { useTable } from "../table/useTable";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

export const useUserDevices = (userId?: string, productCode?: string) => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    currentPage,
    pageSize,
    sortBy,
  } = useTable<MelcoModelsUserDeviceListItem>({
    // pageSizeOptions: [10, 20],
    // pageSize: 20,
  });

  const query = useAPIQuery(
    UserAccountApi,
    ["userDevices", productCode, currentPage, pageSize, filters, sortBy()],
    async (api) => {
      //const api = new UserAccountApi(baseApiConfig({ token, impersonationForId: userId ?? "" }));
      console.log({ filters, currentPage, pageSize });
      let response;
      //   //   if(filters?.Products) {
      response = await api.deviceGetDeviceList({
        productCode: productCode ?? "",
      });
      //}

      setTotal(response?.total ? response?.total : 0);

      return response?.list ? response?.list : [];
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
      apiConfigOptions: {
        impersonationForId: userId ?? "",
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    errorComponent,
    ...query,
  };
};
